import React from 'react'
import axios from '@/utils/myaxios'
import moment from 'moment'
import Cookie from 'js-cookie'
import { Link } from 'react-router-dom'
import {
    Button,
    Table,
    Modal,
    message,
    Radio,
    InputNumber,
    Select,
    Form,
    List,
} from 'antd'
import { tableSummaries, isMobileDevice } from '@/utils/utils'

// 表单数据
const formData = {
    user_id: undefined,
    role: undefined,
    union_ids: [],
}

export default class AccountManage extends React.Component {
    state = {
        loading: false, // 是否加载中
        show: false, // 是否显示弹窗
        type: undefined, // 操作类型
        title: undefined, // 弹窗标题
        data: [], // 表格数据
        formData: formData, // 表单数据
        subUnionList: [], // 子联盟列表
        dataInfo: {}, // 选择的数据
        accountType: [
            // 账号类型
            { label: this.props.language['administrator'], value: 0 },
            { label: this.props.language['service'], value: 1 },
            { label: this.props.language['reconciliation'], value: 2 },
        ],
    }

    componentDidMount () {
        this.fetchData()
        if (Cookie.get('unionType') === 'super_union') {
            this.setState({
                accountType: [
                    ...this.state.accountType,
                    { label: this.props.language['postUnification'], value: 3 },
                ],
            })
            this.fetchSubUnionList()
        }
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true })
        axios.get('/v1/api/union_select_union_admin').then((res) => {
            this.setState({
                loading: false,
                data: res.data || [],
            })
        })
    }

    /**
     * 获取子联盟列表
     */
    fetchSubUnionList = () => {
        axios.get('/v1/api/union_select_union').then((res) => {
            this.setState({
                subUnionList: res.data || [],
            })
        })
    }

    /**
     * 删除数据
     */
    handleDelete = (item) => {
        Modal.confirm({
            title: this.props.language['hint'],
            content: this.props.language['deleteAdminConfirm'],
            onOk: () => {
                axios
                    .patch(
                        item.role === 3
                            ? `/v1/api/super_union_remove_admin_houtong/${item.user_id}`
                            : `/v1/api/union_remove_union_admin/${item.user_id}`,
                        {
                            role: item.role,
                        }
                    )
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(
                                this.props.language['deleteSuccessMessage']
                            )
                            this.fetchData()
                        }
                    })
            },
        })
    }

    /**
     * 添加数据
     */
    handleAdd = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === 'add') {
                    // 添加
                    axios
                        .get('/v1/api/union_select_user', {
                            params: {
                                user_id: values.user_id,
                            },
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                axios
                                    .post(
                                        values.role === 3
                                            ? '/v1/api/super_union_set_admin_houtong'
                                            : '/v1/api/union_set_union_admin',
                                        {
                                            user_id: values.user_id,
                                            union_ids:
                                                values.role === 3
                                                    ? values.union_ids
                                                    : undefined,
                                            role:
                                                values.role !== 3
                                                    ? values.role
                                                    : undefined,
                                        }
                                    )
                                    .then((res) => {
                                        if (res.code === 1) {
                                            message.success(
                                                this.props.language[
                                                'addSuccessMessage'
                                                ]
                                            )
                                            this.handleClose()
                                            this.fetchData()
                                        }
                                    })
                            }
                        })
                } else if (this.state.type === 'edit') {
                    // 编辑
                    axios
                        .post('/v1/api/super_union_set_admin_houtong', {
                            user_id: values.user_id,
                            union_ids: values.union_ids,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language['editSuccessMessage']
                                )
                                this.handleClose()
                                this.fetchData()
                            }
                        })
                }
            }
        })
    }

    /**
     * 显示弹窗
     */
    handleShow = async (type, item) => {
        if (type === 'add') {
            // 新增
            this.setState({
                type,
                show: true,
                title: this.props.language['addAccount'],
            })
        } else if (type === 'edit') {
            // 编辑
            this.setState({
                type,
                show: true,
                title: this.props.language['editAccount'],
                formData: {
                    user_id: item.user_id,
                    role: item.role,
                    union_ids: (() => {
                        if (item.ht_unions && item.ht_unions.length) {
                            return item.ht_unions.map((item2) => item2.union_id)
                        } else {
                            return []
                        }
                    })(),
                },
            })
        } else if (type === 'view') {
            // 查看
            this.setState({
                type,
                show: true,
                title: this.props.language['managementUnion'],
                dataInfo: item,
            })
        }
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields()
        this.setState({ show: false })
    }

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('add')}
                    >
                        {this.props.language['addAccount']}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language['addTime']}
                            dataIndex="added_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['accountId']}
                            dataIndex="user_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['accountName']}
                            dataIndex="user_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['accountType']}
                            dataIndex=""
                            render={(item) =>
                                this.state.accountType.find(
                                    (item2) => item2.value === item.role
                                ) ?
                                    this.state.accountType.find(
                                        (item2) => item2.value === item.role
                                    ).label
                                    : ''
                            }
                        />
                        {Cookie.get('unionType') === 'super_union' && (
                            <Table.Column
                                align="center"
                                title={this.props.language['managementUnion']}
                                dataIndex=""
                                render={(item) => {
                                    return item.ht_unions &&
                                        item.ht_unions.length ? (
                                        <Button
                                            type="link"
                                            onClick={() =>
                                                this.handleShow('view', item)
                                            }
                                        >
                                            {item.ht_unions.length}
                                        </Button>
                                    ) : '/'
                                }}
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={this.props.language['operation']}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : 'right'}
                            width={220}
                            render={(item) => (
                                <>
                                    {item.ht_unions && item.ht_unions.length && (
                                        <Button
                                            type="primary"
                                            className="mr10"
                                            ghost
                                            onClick={() =>
                                                this.handleShow(
                                                    'edit',
                                                    item
                                                )
                                            }
                                        >
                                            {this.props.language['edit']}
                                        </Button>
                                    )}
                                    <Button
                                        type="danger"
                                        ghost
                                        onClick={() => this.handleDelete(item)}
                                    >
                                        {this.props.language['delete']}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    accountType={this.state.accountType}
                    subUnionList={this.state.subUnionList}
                    dataInfo={this.state.dataInfo}
                    onOk={this.handleAdd}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        )
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}
                    footer={
                        this.props.type === 'add' ||
                            this.props.type === 'edit' ? (
                            <>
                                <Button
                                    type="default"
                                    onClick={this.props.onCancel}
                                >
                                    {this.props.language['cancel']}
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={this.props.onOk}
                                >
                                    {this.props.language['confirm']}
                                </Button>
                            </>
                        ) : (
                            false
                        )
                    }
                >
                    <div className="container-content">
                        {/* 添加，编辑 */}
                        {(this.props.type === 'add' ||
                            this.props.type === 'edit') && (
                                <Form>
                                    <Form.Item
                                        label={this.props.language['accountId']}
                                    >
                                        {getFieldDecorator('user_id', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'accountIdVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.user_id,
                                        })(
                                            <InputNumber
                                                precision={0}
                                                min={0}
                                                max={100000000}
                                                disabled={
                                                    this.props.type === 'edit'
                                                }
                                                placeholder={
                                                    this.props.language[
                                                    'accountIdPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={this.props.language['accountType']}
                                    >
                                        {getFieldDecorator('role', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'accountTypeVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue: this.props.formData.role,
                                        })(
                                            <Radio.Group
                                                disabled={
                                                    this.props.type === 'edit'
                                                }
                                            >
                                                {this.props.accountType.map(
                                                    (item, index) => (
                                                        <Radio
                                                            key={index}
                                                            value={item.value}
                                                        >
                                                            {item.label}
                                                        </Radio>
                                                    )
                                                )}
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    {getFieldValue('role') === 3 && (
                                        <Form.Item
                                            label={
                                                this.props.language[
                                                'managementUnion'
                                                ]
                                            }
                                        >
                                            {getFieldDecorator('union_ids', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'managementUnionVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData.union_ids,
                                            })(
                                                <Select
                                                    mode="multiple"
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    placeholder={
                                                        this.props.language[
                                                        'managementUnionPlaceholder'
                                                        ]
                                                    }
                                                >
                                                    {this.props.subUnionList.map(
                                                        (item, index) => (
                                                            <Select.Option
                                                                key={index}
                                                                value={
                                                                    item.union_id
                                                                }
                                                            >
                                                                {item.name}
                                                            </Select.Option>
                                                        )
                                                    )}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    )}
                                </Form>
                            )}

                        {/* 查看 */}
                        {this.props.type === 'view' && (
                            <List
                                bordered
                                dataSource={this.props.dataInfo.ht_unions || []}
                                renderItem={(item) => (
                                    <List.Item>
                                        <span className="mr5">
                                            {item.union_name}
                                        </span>
                                        (
                                        <Link
                                            to={`/union_detail/${item.union_id}`}
                                        >
                                            {item.union_id || ''}
                                        </Link>
                                        )
                                    </List.Item>
                                )}
                            />
                        )}
                    </div>
                </Modal>
            )
        }
    }
)
